import React, { Component } from "react";
import Content from "../../content/Content";
import { Breakpoints } from "../../constants/CssConstants";
import Media from "react-media";

export class GenericHero extends Component {
  GetMatchedImage(matches, srcMob, src) {
    return matches ? (
      <img src={srcMob} alt="" aria-hidden />
    ) : (
      <img src={src} alt="" aria-hidden />
    );
  }

  render() {
    return (
      <div className={"home-hero generic-hero " + this.props.ExtraClasses}>
        <div
          className={
            "home-hero-background " +
            (!this.props.DarkOverlay ? "no-dark-overlay" : "")
          }
        >
          <Content
            names={[
              this.props.HeroBG,
              this.props.HeroBGMobile,
              this.props.Heading
            ]}
          >
            {(src, srcMob, alt) => {
              // If no images and backgroundColor provided, apply background color
              if (!src && !srcMob && this.props.backgroundColor) {
                return (
                  <div style={{ backgroundColor: this.props.backgroundColor, width: '100%', height: '100%', position: 'absolute', top: 0, left: 0 }} />
                );
              }
              // If images exist, render them normally
              if (src || srcMob) {
                return (
                  <Media query={Breakpoints.xsDown}>
                    {(matches) => this.GetMatchedImage(matches, srcMob, src)}
                  </Media>
                );
              }
              // No images and no backgroundColor, render nothing
              return null;
            }}
          </Content>
        </div>
        <div className="home-hero-contents">
          <div className="container">
            <div className="row">
              <div className="col-sm-12">
                <h1>
                  <Content name={this.props.Heading} />
                </h1>
                <div className="box">{this.props.children}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default GenericHero;
